import { useEffect, useState } from "react";
import {
  enableMetrika,
  getConsent,
  isTrackingAllowed,
  setConsent,
} from "./metrika";
import ConsentBannerView from "./ConsentBannerView";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isTrackingAllowed()) return;
    if (getConsent() === null) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <ConsentBannerView
      onAccept={() => {
        setConsent("granted");
        enableMetrika();
        setVisible(false);
      }}
      onDecline={() => {
        setConsent("denied");
        setVisible(false);
      }}
    />
  );
}
